
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Row, Heading } from '@warrenbrasil/nebraska-web';
import { ErrorHandler } from '@/modules/common/components/ErrorHandler';

interface WidgetNavigationLink {
  label: string;
  path: string;
}

@Component({
  name: 'HomeWidget',
  components: {
    Heading,
    Row,
    ErrorHandler
  }
})
export default class HomeWidget extends Vue {
  @Prop({ type: String, required: false })
  readonly title?: string;

  @Prop({ type: Boolean, default: false })
  readonly error?: boolean;

  @Prop({ type: String, required: true })
  readonly errorTitle!: string;

  @Prop({ type: String, default: 'Aguarde alguns minutos e tente novamente.' })
  readonly errorDescription!: string;

  @Prop({ type: [Object, Boolean], required: false })
  readonly navigationLink!: WidgetNavigationLink;

  @Emit('on-navigate')
  public onNavigate() {}

  @Emit('on-retry')
  public retry() {}
}
